// extracted by mini-css-extract-plugin
export default {"live":"ConfHeaderComponent_live__B+VdC"};